export enum Category {
  Main = "main",
  Users = "users",
  Library = "library",
  VenchiMarketplace = "venchiMarketplace",
  Support = "support",
  Forum = "forum",
  Protocols = "protocols",
  Dashboards = "dashboards",
  Reports = "reports",
  ClinicSummary = "ClinicSummary",
  Management = "management",
  videoDiagnostics = "videoDiagnostics",
  Appointments = "appointments",
  TutorialManagement = "tutorialManagement",
  Profile = "profile",
}

export enum ManagementCategories {
  Faq = "faq",
  Card = "card",
  Invoices = "invoices",
  Settings = "settings",
  Plans = "plans",
}

export interface ISubCategory {
  value: string;
  title: string;
  disabled?: boolean;
  typeId?: number;
}

export type TLabeledItem = {
  value: string;
  label: string;
};
export type TLabeledItemWithId = TLabeledItem & {
  id: number | null;
};

export type TQuestionnaireTypeOption = TLabeledItemWithId & {
  Symbol: string;
  Name: string;
};
export type TAddNewQuestionnaireForm = {
  Desc: string;
  Symbol: string;
  StartQuestion: string;
  StatusId: string;
  Date: string | null;
  default: string;
  monthi: string;
  type: number | string;
  EndQuestion: string;
  periodicity?: TLabeledItem;
};

export interface IPopupWithoutProps {
  onClose: () => void;
}

export type TQuestionnaireType = TLabeledItem & {
  Id: number;
  Name: string;
  Symbol: string;
};

export interface IUser {
  [key: string]: any;
  id: string;
  firstName: string;
  lastName: string;
  fullName: string;
  account: string;
  avatar: string;
  email: string;
  phone: string;
  address: string;
  plan: string;
  // therapists: ITherapist[];
  // appointments: IAppointment[];
  // settings: ISettings;
  // prescriptions: IPrescription[];
  // invoices: IInvoice[];
  // videos: IVideo[];
  password: string; //remove when server is ready
  card?: string;
  unreadMessages: number;
  myDayText?: "";
  myTreatmentText?: "";
  passport?: string | null;
  country?: string | null;
  // messages?: IMessage[];
  statusId: number;
  treatmentGroupId?: number | null;
}

export type TUserForm = {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  birth: string;
  genderId: number;
  passport: string;
  fakeCompanyId: number | null;
  roleId: number;
  [key: string]: any;
};

export type TLimits = {
  start: number;
  end: number;
};

export interface IOption {
  value: string;
  label: string;
  desc?: string;
  QuestionnaireCompaniesId?: number;
}
export interface INumberOption extends Omit<IOption, "value"> {
  value: number;
}
export interface INumberOrNullOption extends Omit<IOption, "value"> {
  value: number | null;
}
export interface IBooleanOption extends Omit<IOption, "value"> {
  value: boolean;
}
export type TGroup = {
  Id: number;
  Name: string;
  QuestionsId: number;
};
export type TReportQuestionOption = {
  Id: number;
  QuestionsId: number;
  GroupId: number | null;
  Groups: TGroup | null;
  Desc: string;
  NextQuestionId: number | null;
  NextQuestions: any | null; // Adjust the type of NextQuestions if you know the specific structure or replace 'any' with more specific type
  Seq: number;
  count?: number | null;
  min?: null | number;
};

export type TReportQuestionEmotion = {
  Id: number;
  IsTotal: boolean;
  Name: string;
  NameHe: string | null;
  StatusId: number;
};

export type LangTranslate = {
  language: string;
  translate: string;
  code: string;
};

export type TRiskLevel = "high" | "medium" | "low";

export interface IRiskAlert {
  id: number;
  name: string;
  age: number | null;
  riskLevel: TRiskLevel;
  riskLabel: string; 
  method: string;
  updatedAt: string; 
  time: string; 
  comment?: string;
  actionsPerformed?: string | null; // ✅ הוספת השדות החדשים
  nextSteps?: string | null;         // ✅ הוספת השדות החדשים
}

export interface ISpecializationArea {
  id: number;
  value: number;
  labelKey: string;
}
export type TSpecialization = {
  id: number;
  name: string;
  //  nameEn: string;
  // type: string;
  therapistsSpecializationsTypesId: number;
  statusId: number;
};
export type TLanguage = {
  id: number;
  name: string;
  enName: string;
  statusId: boolean;
  code: string;
  countryCode: string;
};
export type TTherapistSpecialization = {
  id: number;
  statusId: number;
  therapistsSpecializationsId: number;
  usersId: number;
};

export type TLocale = {
  [key: string]: string;
}

export type TLanguageCulture = {
  code: string;
  englishName: string;
  nativeName: string;
  countryCode: string;
};

export type TSessionSummaryReport = {
  language: string;
  bprevenLogoUrl: string;
  companyLogoUrl: string;
  reportDate: string; // Date as ISO string
  therapistName: string;
  patientFirstName: string;
  patientLastName: string;
  referralReasons: string;
  lifeHistory: string;
  mentalStatusAtIntake: string;
  functioningAtIntake: string;
  isDangerObserved: boolean | null;
  isAddictionObserved: boolean | null;
  preliminaryDiagnosisICD10_DSM5: string;
  treatmentPlanAndGoals_AsDeterminedAtIntake_TreatmentFrequency_TherapeuticGoals_OtherNotes: string;
  treatmentCourseDescription_NumberOfSessionsThemesEngagedResponse: string;
  currentMentalStatusAppearanceBehaviorCooperationMoodAffectPerceptionThinkingProcessAndPace: string;
  currentFunctioning: string;
  therapeuticGoalsAchieved: string;
  currentWorkingDiagnosisAccordingTo_ICD10_DSM5: string;
  recommendationsIncludingTreatmentPlanAndUpdatedGoalsIfContinuedTreatmentIsAdvised: string;
  additionalRelevantInformationToAdd: string;
  therapistSignature: string;
  isDigitallySigned: boolean;
  reportsIncludedInSummary: string;
};
export type Report = {
  id: number;
  userId: string;
  therapistId: string;
  createdOn: Date;
  createdBy: string;
  fileUrl: string;
  type: number;
  status: number;
};

export type TCompanySize = {
  id: number;
  min: number;
  max: number;
};
export type TSector = {
  id: number;
  name: string;
};
export type TPaymentPeriodType = {
  id: number;
  name: string;
};
export type TStage = {
  id: number;
  name: string;
  stageNumber: number;

};
